import React, { useState , useEffect} from "react";
import { downloadMonthlyReport } from "../../../Services/ReportService";
import { X } from "lucide-react";

const DownloadReportModal = ({ show, onClose }) => {
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [loading, setLoading] = useState(false);

   useEffect(() => {
    if (!show) {
      setYear("");
      setMonth("");
      setLoading(false);
    }
  }, [show]);

  if (!show) return null;

  const handleDownload = async () => {
    if (!year || !month) {
      alert("Please select Year and Month");
      return;
    }

    try {
      setLoading(true);

      const response = await downloadMonthlyReport(year, month);

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Monthly_Report_${month}_${year}.xlsx`;
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      onClose();
    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download report");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white w-full max-w-md rounded-xl shadow-xl p-6"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">Download Monthly Report</h2>
          <button onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        {/* Year */}
        <div className="mb-4">
          <label className="block text-sm mb-1">Year</label>

          <input
            type="text"
            placeholder="Enter Year (e.g. 2026)"
            value={year}
            maxLength={4}
            onChange={(e) => {
              const value = e.target.value;

              // Allow only digits
              if (/^\d*$/.test(value)) {
                setYear(value);
              }
            }}
            className="w-full border rounded-md px-3 py-2"
          />

          {/* Validation message */}
          {year && year.length !== 4 && (
            <p className="text-red-500 text-xs mt-1">
              Please enter a valid 4-digit year
            </p>
          )}
        </div>

        {/* Month */}
        <div className="mb-4">
          <label className="block text-sm mb-1">Month</label>
          <select
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            className="w-full border rounded-md px-3 py-2"
          >
            <option value="">Select Month</option>
            {[...Array(12)].map((_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </select>
        </div>

        {/* Button */}
        <button
          onClick={handleDownload}
          disabled={loading}
          className="w-full bg-gradient-to-r from-[#0061A4] to-[#00ACED] text-white py-2 rounded-md"
        >
          {loading ? "Downloading..." : "Download Report"}
        </button>
      </div>
    </div>
  );
};

export default DownloadReportModal;
